import { db } from "@/lib/db";
import type { AnalyticsEvent } from "@/types/analytics";

/**
 * Track an analytics event
 */
export async function trackEvent(
  profileId: string,
  eventType: AnalyticsEvent["eventType"],
  metadata?: Record<string, any>
): Promise<void> {
  try {
    const event: AnalyticsEvent = {
      id: crypto.randomUUID(),
      profileId,
      eventType,
      metadata,
      timestamp: Date.now(),
    };

    await db.analyticsEvents.add(event);
  } catch (error) {
    console.error("Failed to track event:", error);
  }
}

